<template>
  <section class="uploadYinbiaoPage">
    <popup v-show="isShowUploadYinbiao" bread="教材管理,课程管理,设置主题资料,编辑自然拼读资料" title="编辑自然拼读资料" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="saveNaturalSpelling">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'编辑自然拼读资料'">
        <h3 class="group-tit">字母资料</h3>
        <el-form
          ref="ref_form"
          class="upload-form-self"
          :model="uploadForm"
          :rules="uploadFormRules"
          label-width="100px"
          @submit.native.prevent
        >
          <el-form-item label="字母" prop="letter">
            <el-input v-model.trim="uploadForm.letter" maxlength="20" placeholder="请输入字母名称" />
          </el-form-item>
          <el-form-item label="字母读音" prop="letterVoice">
            <themeUploadList code="zrpdVoice" :file-list.sync="uploadForm.letterVoice" accept=".mp3" :limit="1" tip="仅支持.mp3文件" />
          </el-form-item>
          <el-form-item label="关联音标" prop="yinbiao">
            <el-select v-model="uploadForm.yinbiao" placeholder="请选择关联音标" style="width: 100%;">
              <el-option v-for="(item, index) in yinbiaoOptions" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="口型视频" prop="videoList">
            <themeUploadList code="zrpdVideo" :file-list.sync="uploadForm.videoList" accept=".mp4" :limit="1" tip="仅支持.mp4文件" />
          </el-form-item>
          <el-form-item label="卡片图" prop="imgFile">
            <themeUploadAvatar ref="uploadCardAvatar" code="zrpdImg" :file-list.sync="uploadForm.imgFile" />
          </el-form-item>
        </el-form>
        <h3 class="group-tit">关联单词<span>（最多关联10个单词）</span></h3>
        <commonEditWord
          ref="ref_commonUploadWord"
          :key="timestamp"
          :form.sync="uploadForm"
          :max-number="10"
          code="zrpd"
          @formChange="commonUpEditWordChange"
        />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import themeUploadAvatar from '../components/themeUploadAvatar'
import themeUploadList from '../components/themeUploadList'
import commonEditWord from '../components/commonEditWord'
import { functionData } from '../../../../utils/reg'
import _ from 'lodash'
import { editNaturalSpellingApi } from '../../../../api/teachBookManagement/courseManagement'
import { mapState } from 'vuex'
export default {
  components: {
    themeUploadAvatar,
    themeUploadList,
    commonEditWord
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadYinbiao: false,
      uploadForm: {
        letter: '',
        letterVoice: [],
        // 关联音标
        yinbiao: '',
        imgFile: [],
        videoList: [],
        wordList: []
      },
      commonUploadForm: {},
      uploadFormRules: {
        letter: [{ required: true, message: '请输入字母名称', trigger: 'blur' }],
        yinbiao: [{ required: true, message: '请选择关联音标', trigger: 'change' }],
        letterVoice: [{ required: true, message: '请上传字母读音音频', trigger: 'change' }],
        imgFile: [{ type: 'array', required: true, message: '请上传卡片图', trigger: 'change' }],
        videoList: [{ required: true, message: '请上传口型视频', trigger: 'blur' }]
      },
      yinbiaoOptions: [
        { code: 'aa', name: 'ɑː' },
        { code: 'ae', name: 'æ' },
        { code: 'ah', name: 'ʌ' },
        { code: 'ao', name: 'ɔː' },
        { code: 'ar', name: 'eə' },
        { code: 'aw', name: 'aʊ' },
        { code: 'ax', name: 'ə' },
        { code: 'ay', name: 'aɪ' },
        { code: 'eh', name: 'e' },
        { code: 'er', name: 'ɜː' },
        { code: 'ey', name: 'eɪ' },
        { code: 'ih', name: 'ɪ' },
        { code: 'ir', name: 'ɪə' },
        { code: 'iy', name: 'iː' },
        { code: 'oo', name: 'ɒ' },
        { code: 'ow', name: 'əʊ' },
        { code: 'oy', name: 'ɒɪ' },
        { code: 'uh', name: 'ʊ' },
        { code: 'uw', name: 'uː' },
        { code: 'ur', name: 'ʊə' },
        { code: 'b', name: 'b' },
        { code: 'ch', name: 'tʃ' },
        { code: 'd', name: 'd' },
        { code: 'dh', name: 'ð' },
        { code: 'f', name: 'f' },
        { code: 'g', name: 'g' },
        { code: 'hh', name: 'h' },
        { code: 'jh', name: 'dʒ' },
        { code: 'k', name: 'k' },
        { code: 'l', name: 'l' },
        { code: 'm', name: 'm' },
        { code: 'n', name: 'n' },
        { code: 'ng', name: 'ŋ' },
        { code: 'p', name: 'p' },
        { code: 'r', name: 'r' },
        { code: 's', name: 's' },
        { code: 'sh', name: 'ʃ' },
        { code: 't', name: 't' },
        { code: 'th', name: 'θ' },
        { code: 'v', name: 'v' },
        { code: 'w', name: 'w' },
        { code: 'y', name: 'j' },
        { code: 'z', name: 'z' },
        { code: 'zh', name: 'ʒ' },
        { code: 'dr', name: 'dr' },
        { code: 'dz', name: 'dz' },
        { code: 'tr', name: 'tr' },
        { code: 'ts', name: 'ts' }
      ]

    }
  },
  computed: {
    ...mapState('settingThemeData', ['naturalSpellingEditList', 'editShow'])

  },
  watch: {
    timestamp: function (val) {
      this.isShowUploadYinbiao = true
      this.dataChange()
    }
  },
  created () {

  },
  mounted() {
  },

  // updated(){
  //   console.log('更新了')
  // },
  methods: {
    dataChange() {
      // this.uploadForm = deepClone.deepClone(this.naturalSpellingEditList)
      this.uploadForm.letter = this.naturalSpellingEditList[0].wordName
      this.uploadForm.id = this.naturalSpellingEditList[0].id
      this.uploadForm.naturalSpellingCode = this.naturalSpellingEditList[0].naturalSpellingCode
      this.uploadForm.imgFile = [
        { name: this.naturalSpellingEditList[0].cardChartFileName,
          id: this.naturalSpellingEditList[0].id,
          url: this.naturalSpellingEditList[0].rootCardChartPath,
          fileName: this.naturalSpellingEditList[0].cardChartName,
          rootUrl: this.naturalSpellingEditList[0].cardChartPath
        }]
      this.uploadForm.videoList = [
        {
          name: this.naturalSpellingEditList[0].mouthShapeFileName,
          id: this.naturalSpellingEditList[0].id,
          url: this.naturalSpellingEditList[0].rootMouthShapePath,
          fileName: this.naturalSpellingEditList[0].mouthShapeName,
          rootUrl: this.naturalSpellingEditList[0].mouthShapePath
        }
      ]
      this.uploadForm.letterVoice = [
        {
          name: this.naturalSpellingEditList[0].pronunciationFileName,
          url: this.naturalSpellingEditList[0].rootPronunciationPath,
          id: this.naturalSpellingEditList[0].id,
          fileName: this.naturalSpellingEditList[0].pronunciationName,
          rootUrl: this.naturalSpellingEditList[0].pronunciationPath
        }
      ]
      this.uploadForm.yinbiao = this.naturalSpellingEditList[0].phrasesName
      const array = []
      this.naturalSpellingEditList[0].basicMeansResList.forEach(e => {
        const objs = e
        objs.parentId = this.naturalSpellingEditList[0].id
        objs.voice = functionData(e, 'pronunciation', 'Pronunciaion')
        objs.img = functionData(e, 'cardChart', 'CardChart')
        objs.video = functionData(e, 'mouthShape', 'MouthShape')
        array.push(objs)
      })
      this.uploadForm.wordList = _.cloneDeep(array)
    },
    // 返回
    popup_back () {
      this.$refs['ref_form'].resetFields()
      this.isShowUploadYinbiao = false
      this.$store.commit('settingThemeData/SET_RESETLIST')
    },
    commonUpEditWordChange (form) {
      this.commonUploadForm = form
    },
    saveNaturalSpelling () {
      this.$refs['ref_form'].validate((valid) => {
        this.$refs.ref_commonUploadWord.validateForm()
        if (!valid || !this.$refs.ref_commonUploadWord.validateForm()) {
          this.$message.error('请正确填写信息')
          return false
        }
        console.log(this.uploadForm)
        const params = {
          id: this.uploadForm.id,
          wordName: this.uploadForm.letter,
          phoneticPronunciationName: this.uploadForm.letterVoice[0].paramsFileName || this.uploadForm.letterVoice[0].fileName,
          phoneticPronunciationPath: this.uploadForm.letterVoice[0].rootUrl || this.uploadForm.letterVoice[0].paramsUrl,
          phrasesName: this.uploadForm.yinbiao,
          cardChartName: this.uploadForm.imgFile[0].paramsFileName || this.uploadForm.imgFile[0].fileName,
          cardChartPath: this.uploadForm.imgFile[0].rootUrl || this.uploadForm.imgFile[0].paramsUrl,
          teachingThemeId: this.themeRow.id,
          mouthShapeName: this.uploadForm.videoList[0].paramsFileName || this.uploadForm.videoList[0].fileName,
          mouthShapePath: this.uploadForm.videoList[0].rootUrl || this.uploadForm.videoList[0].paramsUrl,
          meansType: 3,
          naturalSpellingCode: this.uploadForm.id,
          naturalSpellingList: []
        }
        for (const item of this.uploadForm.wordList) {
          params.naturalSpellingList.push({
            wordName: item.wordName,
            parentId: this.uploadForm.id,
            cardChartName: item.img[0].paramsFileName || item.img[0].fileName,
            cardChartPath: item.img[0].matchPathName || item.img[0].paramsUrl,
            phoneticPronunciationName: item.voice[0].paramsFileName || item.voice[0].fileName,
            phoneticPronunciationPath: item.voice[0].matchPathName || item.voice[0].paramsUrl,
            mouthShapeName: item.video[0].paramsFileName || item.video[0].fileName,
            mouthShapePath: item.video[0].matchPathName || item.video[0].paramsUrl,
            teachingThemeId: this.themeRow.id,
            meansType: 4,
            id: item.id
          })
        }
        try {
          console.log(params)
          editNaturalSpellingApi(params).then(res => {
            this.$message.success('修改成功')
            this.popup_back()
            this.$emit('resetFetchData')
          })
        } catch (e) {
          this.$message.closeAll()
          this.$message.error(e)
        }
      })
    }
  }
}
</script>

<style lang='scss'>
.uploadYinbiaoPage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #EEEEEE;border-radius: 8px;padding:24px 0 0 0;
  .el-form-item{
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
